import { SVGProps, Ref, forwardRef } from 'react';

export const FlGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M1 5.4A4.4 4.4 0 0 1 5.4 1h13.2A4.4 4.4 0 0 1 23 5.4v13.2a4.4 4.4 0 0 1-4.4 4.4H5.4A4.4 4.4 0 0 1 1 18.6z"
            fill="#919191"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.24 7.628a1 1 0 0 0-.06-.25.34.34 0 0 0-.094-.133.2.2 0 0 0-.121-.041H7.654a.62.62 0 0 0-.419.144q-.17.145-.17.473v8.72a.21.21 0 0 0 .05.142.4.4 0 0 0 .161.1q.15.048.306.063.245.025.491.023.212.003.423-.023.156-.015.305-.063a.34.34 0 0 0 .162-.1.23.23 0 0 0 .046-.142v-3.553h2.76a.2.2 0 0 0 .12-.041.35.35 0 0 0 .095-.138 1 1 0 0 0 .06-.245q.02-.185.019-.371a4 4 0 0 0-.019-.41.8.8 0 0 0-.06-.241.3.3 0 0 0-.094-.126.2.2 0 0 0-.12-.037H9.007V8.806h2.956a.18.18 0 0 0 .12-.044.4.4 0 0 0 .095-.134.8.8 0 0 0 .06-.241q.02-.187.02-.376a3 3 0 0 0-.019-.383"
            fill="#E2E2E2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.583 15.667a1 1 0 0 0-.066-.247.3.3 0 0 0-.111-.134.3.3 0 0 0-.156-.041h-2.549v-7.8a.2.2 0 0 0-.057-.135.43.43 0 0 0-.19-.097 2 2 0 0 0-.356-.06 6 6 0 0 0-.56-.022 5 5 0 0 0-.516.022q-.185.015-.361.06a.4.4 0 0 0-.191.097.2.2 0 0 0-.057.135v8.804q0 .328.2.474c.137.098.313.15.493.146h4.144a.27.27 0 0 0 .155-.046q.079-.06.112-.145.05-.123.066-.254.045-.376 0-.754z"
            fill="#E2E2E2"
        />
    </svg>
));
FlGrayscaleSize24Glyph.displayName = 'FlGrayscaleSize24Glyph';
